import { useEffect, useState } from "react";
import { useMainContext } from "../../Context";
import { footerData, newsLetter } from "../../Utils/Apis";

export const useMainLayout = () => {
  const [loading, setLoading] = useState(true);
  const [loadingbtn, setLoadingBtn] = useState(false);
  const [form, setForm] = useState({ email: "" });
  const {
    post,
    isLogin,
    handler,
    state: { mainData },
  } = useMainContext();
  const getData = async () => {
    setLoading(true);
    const { data, status } = await post(footerData);
    if (+status == 200) {
      handler("mainData", data);
      setLoading(false);
    }
  };
  useEffect(() => {
    if (mainData){
      setLoading(false);
      return;
    } 
    getData();
  }, []);
  const sendEmail = async () => {
    setLoadingBtn(true);
    const { status } = await post(newsLetter, { ...form }, true);
    setForm({ email: "" });
    setLoadingBtn(false);
  };

  return { isLogin, loading, mainData, form, setForm, sendEmail, loadingbtn };
};
